import { autoinject, bindingMode } from 'aurelia-framework';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { bindable } from 'aurelia-typed-observable-plugin';
import { validateEmail } from 'app/shared/lib/validation/validation-utilities';

@autoinject()
export class EditEmailCustomElement extends ComponentBase {

    ////****************** Fields and Properties ************************************////
    @bindable.string({ defaultBindingMode: bindingMode.twoWay })
    protected email: string | null = null;

    @bindable.boolean()
    protected required: boolean = false;

    @bindable.stringNull()
    public label: string | null = null;

    @bindable.stringNull()
    public placeholder: string | null = null;

    @bindable.stringNull()
    protected icon: string | null = null;

    @bindable.boolean
    public disabled: boolean = false;

    @bindable.boolean
    public readonly: boolean = false;

    @bindable.string()
    public testName: string = '';

    @bindable.number
    public maxLength: number = 320;

    @bindable.string()
    protected labelIconTooltip: string | null = null;

    protected validateEmail = validateEmail;

    ////****************** Element References ***************************************////


    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(...rest: any[]) {
        super(...rest);
        this.logger.source = this;
    }

    ////****************** Events ***************************************************////


    ////****************** Functions ************************************************////


    ////****************** Service Calls ********************************************////

}
